// @ts-nocheck
// import StyledWrapper from "@insite/client-framework/Common/StyledWrapper"; // Store Custom Code
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import updateConfigurationSelection from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateConfigurationSelection";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select, { SelectProps } from "@insite/mobius/Select";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
// import { connect, ResolveThunks } from "react-redux"; // Store Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { productDetailsFormWrapperStyles } from "@store/Themes/common/mixins/productDetails";
import { formSmallGridProps } from "@store/Themes/common/props/form";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import { ProductModel, SectionOptionModel } from "@insite/client-framework/Types/ApiModels";
import ProductPartNumbers from "@insite/content-library/Components/ProductPartNumbers";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import DynamicDropdown, { OptionObject } from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";
import { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import ProductImage from "@store/Overrides/Components/ProductImage";
import { imageStyles } from "@store/Themes/common/mixins/image";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { getFilteredConfigurable } from "@store/Framework/Store/Store/Data/FilteredConfigurable/FilteredConfigurableSelector";
import displayProductList from "@store/Framework/Store/Store/Data/Products/Handlers/DisplayProductList";
import clearConfigurationSelection from "@store/Framework/Store/Store/Pages/ProductDetails/Handlers/ClearConfigurationSelection";
import ProductAvailabilityWithPickup from "@store/Library/Components/ProductAvailabilityWithPickup";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useProductsDataView } from "@toolkit/Framework/Store/Data/Products/ProductsHooks";
import find from "lodash/find";
import { connect, ResolveThunks, useDispatch } from "react-redux";
/* Store Custom Code - End */

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasParentProductId;

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => {
    const productState = getProductState(state, ownProps.parentProductId).value;
    /* Store Custom Code - Start */
    const filteredConfigurableData = getFilteredConfigurable(state, ownProps.parentProductId);

    const configuration = productState?.detail?.configuration;
    const productIds =
        configuration && configuration.configSections
            ? configuration.configSections.reduce((acc, section) => {
                  if (section.sectionOptions) {
                      section.sectionOptions.forEach(option => {
                          if (option.productId && !acc.includes(option.productId)) {
                              acc.push(option.productId);
                          }
                      });
                  }
                  return acc;
              }, [] as string[])
            : [];
    /* Store Custom Code - End */
    return {
        configurationType: productState?.configurationType,
        configuration: productState?.detail?.configuration,
        configurationSelection: state.pages.productDetails.configurationSelection,
        // Store Custom Code
        productIds,
        filteredConfigurableData,
    };
};

const mapDispatchToProps = {
    updateConfigurationSelection,
    clearConfigurationSelection,
};

export interface ProductDetailsBundleSectionOptionsStyles {
    wrapper?: InjectableCss;
    select?: SelectProps;
    // Starter Custom Code
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    // Store Custom Code
    clearLink?: LinkPresentationProps;
    autocompleteWrapper?: InjectableCss;
    autocompleteImageWrapper?: InjectableCss;
    autocompleteInfoWrapper?: InjectableCss;
    autocompleteModelNumber?: TypographyPresentationProps;
    autocompleteModelDescription?: TypographyPresentationProps;
    autocompleteUnset?: TypographyPresentationProps;
    technicalSection?: InjectableCss;
    technicalTitle?: TypographyPresentationProps;
    filterTextIcon?: IconPresentationProps;
}

export const variantOptionsStyles: ProductDetailsBundleSectionOptionsStyles = {
    wrapper: { css: productDetailsFormWrapperStyles() },
    gridContainer: formSmallGridProps.gridContainer,
    // Starter Custom Code
    gridItem: {
        width: 12,
        // Store Custom Code
        css: css`
            li[role="option"]:not([disabled]):hover svg {
                color: ${getColor("common.background")};
            }
        `,
    },
    // Store Custom Code
    clearLink: {
        css: css`
            ${linkActionStyles(pxToRem(16))}
            align-items: flex-start;
            margin: 0.75em 0 1em;
        `,
    },
    autocompleteWrapper: {
        css: css`
            display: flex;
            align-items: center;
            gap: ${pxToRem(10)};
        `,
    },
    autocompleteImageWrapper: {
        css: css`
            ${x => imageStyles(x.theme.design.product.image.small.ratio)}
            width: ${pxToRem(50)};
            flex: 0 0 auto;
        `,
    },
    autocompleteInfoWrapper: {
        css: css`
            display: flex;
            width: 0%;
            flex: 1 0 auto;
            flex-direction: column;
        `,
    },
    autocompleteModelNumber: {
        css: css`
            float: left;
        `,
    },
    autocompleteUnset: {
        ellipsis: true,
        css: css`
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    technicalTitle: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    technicalSection: {
        css: css`
            margin-bottom: 0.5em;
        `,
    },
    filterTextIcon: {
        src: X,
        css: css`
            margin-right: ${pxToRem(4)};
        `,
    },
};

const styles = variantOptionsStyles;
const StyledSpan = getStyledWrapper("span"); // Store Custom Code

const ProductDetailsBundleSectionOptions = ({
    configurationType,
    configuration,
    configurationSelection,
    updateConfigurationSelection,
    parentProductId,
    // Store Custom Code
    clearConfigurationSelection,
    productIds,
    filteredConfigurableData,
}: Props) => {
    const [isLoading, setIsLoading] = React.useState<boolean>(true); // Store Custom Code
    const sectionOptionChangeHandler = (configSectionId: string, sectionOptionId: string) => {
        setIsLoading(true); // Store Custom Code
        updateConfigurationSelection({ configSectionId, sectionOptionId, productId: parentProductId });
    };
    /* Store Custom Code - Start */
    const dispatch = useDispatch();
    const { product } = React.useContext(ProductContext);
    const parameters = React.useMemo(() => {
        return { productIds, apiType: "bundleSectionOption", widgetId: product.id };
    }, [productIds]);
    const productsDataView = useProductsDataView(parameters);
    React.useEffect(() => {
        if (
            product?.detail?.configuration?.configSections &&
            product?.detail?.configuration.configSections[0].sectionOptions
        ) {
            updateConfigurationSelection({
                configSectionId: product?.detail?.configuration.configSections[0].id,
                sectionOptionId: product?.detail?.configuration.configSections[0].sectionOptions[0].id,
                productId: parentProductId,
            });
        } else {
            setIsLoading(false);
        }
    }, []);
    React.useEffect(() => {
        if (!productsDataView.value && !productsDataView.isLoading) {
            dispatch(displayProductList(parameters));
        }
    }, [parameters]);

    React.useEffect(() => {
        setIsLoading(false);
    }, [filteredConfigurableData]);

    function getConfigsAllowedToChange(obj: SafeDictionary<string>): string[] | null {
        const keys = Object.keys(obj);
        let lastFilledKey: string | null = null;
        let nextKey: string | null = null;

        for (let i = 0; i < keys.length; i++) {
            if (obj[keys[i]] !== undefined && obj[keys[i]] !== "") {
                lastFilledKey = keys[i];
                nextKey = keys[i + 1] || null;
            }
        }
        if (lastFilledKey && nextKey) {
            return [lastFilledKey, nextKey];
        }
        if (lastFilledKey && !nextKey) {
            return [lastFilledKey];
        }
        return [keys[0]];
    }

    const clearData = () => {
        clearConfigurationSelection({ productId: parentProductId });
    };

    const getProductById = (option: SectionOptionModel): ProductModel | null | undefined => {
        if (!productsDataView || !productsDataView.value || !option.productId) {
            return null;
        }
        return find(productsDataView.value, { id: option.productId }) || null;
    };

    const mapOptions = (options: SectionOptionModel[]): OptionObject[] => {
        if (!options || options.length < 1) {
            return [];
        }
        const mappedOptions: OptionObject[] = options.map((optionModel, i) => {
            const product = getProductById(options[i]);
            if (!product) {
                return {
                    optionText: optionModel.description,
                    optionValue: optionModel.id || undefined,
                };
            }
            const description =
                ("productTitle" in product && product.productTitle) ||
                ("shortDescription" in product && product.shortDescription) ||
                ("description" in product && product.description) ||
                "";
            return {
                optionText: optionModel.description,
                optionValue: optionModel.id || undefined,
                rowChildren: product ? (
                    <StyledWrapper {...styles.autocompleteWrapper}>
                        <StyledSpan {...styles.autocompleteImageWrapper}>
                            <ProductImage product={product} size="small" />
                        </StyledSpan>
                        <StyledSpan {...styles.autocompleteInfoWrapper}>
                            <ProductPartNumbers
                                productNumber={product.productNumber}
                                customerProductNumber={product.customerProductNumber}
                                manufacturerItem={product.manufacturerItem}
                                showCustomerName={false}
                                showManufacturerItem={false}
                            />
                            <Typography {...styles.autocompleteModelDescription}>{description}</Typography>
                            <ProductAvailabilityWithPickup
                                isProductDetailsPage={false}
                                isScratchAndDent={product?.properties?.isScratchAndDent}
                                dcneAvailability={product?.properties?.availabilityStatus}
                                canAddToCart={product?.canAddToCart}
                                isStandardKit={
                                    product &&
                                    !!product.configurationType &&
                                    product.configurationType !== ConfigurationType.None &&
                                    product.configurationType !== ConfigurationType.Fixed
                                }
                            />
                        </StyledSpan>
                    </StyledWrapper>
                ) : undefined,
            };
        });

        return mappedOptions || [];
    };
    /* Store Custom Code - End */

    if (
        !configuration ||
        configuration.isKit ||
        !configuration.configSections ||
        configuration.configSections.length === 0 ||
        configurationType === ConfigurationType.None
    ) {
        return null;
    }

    const enabledKeys = getConfigsAllowedToChange(configurationSelection); // Store Custom Code

    return (
        <StyledWrapper {...styles.wrapper}>
            <LoadingOverlay
                loading={!productsDataView.value || productsDataView.isLoading || isLoading} /* Store Custom Code */
            >
                {/* Store Custom Code - Start */}
                {filteredConfigurableData?.voltage && (
                    <StyledWrapper {...styles.technicalSection}>
                        <Typography {...styles.technicalTitle}>{translate("Voltage:")}</Typography>{" "}
                        {filteredConfigurableData?.voltage}
                    </StyledWrapper>
                )}
                {filteredConfigurableData?.currentBtu && filteredConfigurableData?.maxBtu ? (
                    <StyledWrapper {...styles.technicalSection}>
                        <Typography {...styles.technicalTitle}>{translate("BTU:")}</Typography>{" "}
                        {(
                            (parseFloat(filteredConfigurableData?.currentBtu) /
                                parseFloat(filteredConfigurableData?.maxBtu)) *
                            100
                        ).toFixed(0)}
                        %
                    </StyledWrapper>
                ) : null}
                {/* Store Custom Code - End */}
                <GridContainer {...styles.gridContainer} /* Starter Custom Code */>
                    {configuration.configSections.map(
                        configSection =>
                            !!configSection.sectionOptions?.length && (
                                <GridItem key={configSection.id} {...styles.gridItem} /* Starter Custom Code */>
                                    {/* Store Custom Code - Start */}
                                    <DynamicDropdown
                                        label={configSection.label || configSection.sectionName}
                                        disabled={!enabledKeys?.includes(configSection.id)}
                                        options={[
                                            {
                                                optionText: "Unset selection",
                                                optionValue: "",
                                                rowChildren: (
                                                    <Typography {...styles.autocompleteUnset}>
                                                        <Icon {...styles.filterTextIcon} />
                                                        {translate("Unset selection")}
                                                    </Typography>
                                                ),
                                            },
                                            ...mapOptions(configSection.sectionOptions),
                                        ]}
                                        selected={configurationSelection[configSection.id]}
                                        sizeVariant="small"
                                        onSelectionChange={value => {
                                            sectionOptionChangeHandler(configSection.id, value || "");
                                        }}
                                    />
                                    {/* Store Custom Code - End */}
                                </GridItem>
                            ),
                    )}
                </GridContainer>
                {/* Store Custom Code - Start */}
                <Link {...styles.clearLink} onClick={clearData}>
                    <Typography>{translate("Clear selection")}</Typography>
                </Link>
                {/* Store Custom Code - End */}
            </LoadingOverlay>
            {/* Store Custom Code */}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withParentProductId(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsBundleSectionOptions)),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
